// Public reCAPTCHA v3 site key (safe to ship; the secret lives in the RECAPTCHA_SECRET Firebase secret)
export const RECAPTCHA_SITE_KEY = '6Lc9ttQtAAAAAAunUtI1EwVRATlnST4Fp27wvkBp';
